import { getAppVersionFromUserAgent, isMock } from "./common";
import { compareVersions } from "compare-versions";

/**
 * 根据 semver 规则判断当前 APP 版本是否 > 指定版本
 * @param targetVersion 目标版本号
 * @returns boolean
 */
export function isAppVersionGreaterThan(targetVersion?: string): boolean {
  if(!targetVersion) return false;
  const currentVersion = getAppVersionFromUserAgent();
  const currentVersionStr = currentVersion.join(".");
  console.log('currentVersion:', currentVersionStr, 'targetVersion:', targetVersion);
  console.log('isAppVersionGreaterThan', compareVersions(currentVersionStr, targetVersion) > 0);
  return compareVersions(currentVersionStr, targetVersion) > 0;
}

/**
 * 根据 semver 规则判断当前 APP 版本是否 >= 指定版本
 * @param targetVersion 目标版本号
 * @returns boolean
 */
export function isAppVersionGreaterThanOrEqualTo(
  targetVersion?: string
): boolean {
  if (isMock()) return true;
  if(!targetVersion) return false;
  const currentVersion = getAppVersionFromUserAgent();
  const currentVersionStr = currentVersion.join(".");
  console.log('currentVersion:', currentVersionStr, 'targetVersion:', targetVersion);
  console.log('isAppVersionGreaterThanOrEqualTo', compareVersions(currentVersionStr, targetVersion) >= 0);
  return compareVersions(currentVersionStr, targetVersion) >= 0;
}

/**
 * 根据 semver 规则判断当前 APP 版本是否 < 指定版本
 * @param targetVersion 目标版本号
 * @returns boolean
 */
export function isAppVersionLessThan(targetVersion?: string): boolean {
  if(!targetVersion) return false;
  const currentVersion = getAppVersionFromUserAgent();
  const currentVersionStr = currentVersion.join(".");
  return compareVersions(currentVersionStr, targetVersion) < 0;
}

/**
 * 根据 semver 规则判断当前 APP 版本是否 <= 指定版本
 * @param targetVersion 目标版本号
 * @returns boolean
 */
export function isAppVersionLessThanOrEqualTo(targetVersion?: string): boolean {
  if(!targetVersion) return false;
  const currentVersion = getAppVersionFromUserAgent();
  const currentVersionStr = currentVersion.join(".");
  return compareVersions(currentVersionStr, targetVersion) <= 0;
}

/**
 * 根据 semver 规则判断当前 APP 版本是否 == 指定版本
 * @param targetVersion 目标版本号
 * @returns boolean
 */
export function isAppVersionEqualTo(targetVersion?: string): boolean {
  if(!targetVersion) return false;
  const currentVersion = getAppVersionFromUserAgent();
  const currentVersionStr = currentVersion.join(".");
  return compareVersions(currentVersionStr, targetVersion) === 0;
}
